<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Edit Data Program</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Nama Program"
                class="mb-0 required"
                type="text"
                required
                horizontal
                placeholder="Nama Program"
                :isValid="validate.program_name.isValid"
                :invalidFeedback="validate.program_name.message"
                v-model.trim="programData.program_name"
                @change="handleProgramName"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                id="program_slug"
                label="Program Url Name"
                class="mb-0 required"
                type="text"
                required
                horizontal
                placeholder="Program Url Name"
                :isValid="validate.program_slug.isValid"
                :invalidFeedback="validate.program_slug.message"
                v-model.trim="programData.program_slug"
                @change="handleProgramSlug"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CTextarea
                id="meta_description"
                label="Meta Description"
                class="mb-0"
                type="text"
                horizontal
                placeholder="Meta Description"
                v-model="programData.meta_info_description"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CTextarea
                id="meta_description"
                label="Meta Keyword"
                class="mb-0"
                type="text"
                horizontal
                placeholder="Meta Keyword"
                v-model="programData.meta_info_keyword"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Jenis Program"
                class="required"
                :options="options"
                required
                horizontal
                disabled
                :isValid="validate.program_type.isValid"
                :invalidFeedback="validate.program_type.message"
                v-model="programData.program_type"
                @change="handleProgramType"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Active Date"
                class="mb-0 required"
                type="date"
                required
                horizontal
                placeholder="Nama Program"
                :isValid="validate.active_date.isValid"
                :invalidFeedback="validate.active_date.message"
                v-model.trim="programData.active_date"
                @change="handleActiveDate"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="Expired Date"
                class="mb-0 required"
                type="date"
                required
                horizontal
                placeholder="Nama Program"
                :isValid="validate.expiry_date.isValid"
                :invalidFeedback="validate.expiry_date.message"
                v-model="programData.expiry_date"
                @change="handleExpireDate"
              />
            </CCol>
          </CRow>
          <CRow class="form-group mt-5">
            <CCol :col="12" v-if="programType === 'With Content'">
              <a>Deskripsi Promo</a>
              <editor
                id="editor"
                :class="showErrorField && !programData.program_description ? 'is-invalid' : ''"
                :api-key="tinyMceKey"
                :init="initOption"
                v-model="programData.program_description"
              />
               <div class="invalid-feedback">
                {{validate.program_description.message}}
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group mb-5">
            <CCol :col="12" v-if="programType === 'With Content'">
              <a>Syarat & Ketentuan</a>
               <editor
                id="editor2"
                :class="showErrorField && !programData.program_term_condition ? 'is-invalid' : ''"
                :api-key="tinyMceKey"
                :init="initOption"
                v-model="programData.program_term_condition"
              />
              <div class="invalid-feedback">
                {{validate.program_term_condition.message}}
              </div>
            </CCol>
          </CRow>
          <CRow class="form-group" v-if="programType === 'Fix Link'">
            <CCol :col="8">
              <CInput
                label="URL Link"
                class="mb-0"
                type="text"
                required
                horizontal
                placeholder="URL Link"
                v-model.trim="programData.program_url"
                @change="handleProgramUrl"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="warning-input" v-if="imageIs === 'KOSONG'">
                Banner Image di perlukan
              </div>
              <CInputFile
                class="required"
                label="Banner Image"
                horizontal
                type="file"
                :isValid="validate.attachment_program_photo_url.isValid"
                :invalidFeedback="validate.attachment_program_photo_url.message"
                @change="readURL"
                accept=".png, .jpg, .jpeg, .webp"
              >
                <template v-slot:label-after-input>
                  File size should be below 250KB and Optimize picture size is 720px
                  x 360px.
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="url" :src="url" />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="ALT Banner Image"
                class="mb-0"
                type="text"
                horizontal
                placeholder="ALT Banner Image"
                v-model="programData.alt_program_photo_url"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <div class="warning-input" v-if="imageIs === 'KOSONG'">
                Foto Ilustrasi di perlukan
              </div>
              <CInputFile
              class="required"
                label="Card Image"
                horizontal
                type="file"
                :isValid="validate.attachment_program_subphoto_url.isValid"
                :invalidFeedback="validate.attachment_program_subphoto_url.message"
                @change="readSubPhotoURL"
                accept=".png, .jpg, .jpeg, .webp"
              >
                <template v-slot:label-after-input>
                     File size should be below 150KB and Optimize picture size is 300px x 150px
                </template>
              </CInputFile>
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <img class="image-ilustrasi" id="myImg" v-if="subPhotoUrl" :src="subPhotoUrl" />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CInput
                label="ALT Card Image"
                class="mb-0"
                type="text"
                horizontal
                placeholder="ALT Card Image"
                v-model="programData.alt_program_subphoto_url"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="8">
              <CSelect
                label="Status"
                :options="optionsStatus"
                required
                horizontal
                v-model="programData.status"
                @change="handleStatusProgram"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton
                color="success"
                class="float-right"
                @click="updateProgram"
                >Submit</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import jwt from "jsonwebtoken";
import Editor from "@tinymce/tinymce-vue";
import initTinymce from "@/app/constants/initTinymce";

export default {
  name: "ProgramEdit",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.usersOpened = from.fullPath.includes("usercreate");
    });
  },
  components: { Editor },
  data() {
    return {
      tinyMceKey: initTinymce.key,
      programDataNew: {},
      programData: {},
      showErrorField: false,
      isEdited: false,
      programType: "",
      imageIs: "ADA",
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
      options: ["With Content", "Fix Link"],
      optionsStatus: ["ACTIVE", "INACTIVE"],
      content1: "",
      content2: "",
      url: null,
      alt_program_photo_url: "",
      subPhotoUrl: null,
      alt_program_subphoto_url: "",
      arrayPhoto: [],
      bannerImgDimension: {},
      cardImgDimension: {},
      initOption: initTinymce.init,
    };
  },
  mounted() {
    this.authentication();
    let ProgramID = this.$route.params.id;
    axios
      .get(`${this.domain}/v1/program/data/${ProgramID}`, {
        headers: {
          Authorization: this.token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        // JSON responses are automatically parsed.
          this.programData = response.data;
        this.programData.active_date = moment(
          String(this.programData.active_date)
        ).format("YYYY-MM-DD");
        this.programData.expiry_date = moment(
          String(this.programData.expiry_date)
        ).format("YYYY-MM-DD");
        this.programType = this.programData.program_type;
        this.content1 = this.programData.program_description;
        this.content2 = this.programData.program_term_condition;
        this.url = this.programData.attachment_program_photo_url;
        this.subPhotoUrl = this.programData.attachment_program_subphoto_url;
        this.programDataNew = {...this.programData}
        this.addImageProcess(this.url).then((result) => {
          this.bannerImgDimension = result
        })
        this.addImageProcess(this.subPhotoUrl).then((result) => {
          this.cardImgDimension = result
        }).catch(() => {
          this.cardImgDimension = {
            width: 0,
            height: 0
          }
        })
      })
      .catch((e) => {
        console.log(e);
      });
  },
  computed: {
    validate() {
      return {
        program_name: {
          isValid: this.CheckIsValid(this.programData.program_name),
          error: !this.programData.program_name,
          message: "Nama Program harus diisi"
        },
        program_slug: {
          isValid: this.CheckIsValid(this.programData.program_slug),
          error: !this.programData.program_slug,
          message: "Program URL Name harus diisi"
        },
        program_type: {
          isValid: this.CheckIsValid(this.programData.program_type),
          error: !this.programData.program_type,
          message: "Jenis Program harus diisi"
        },
        active_date: {
          isValid: this.CheckIsValid(this.programData.active_date),
          error: !this.programData.active_date,
          message: "Active Date harus diisi"
        },
        expiry_date: {
          isValid: this.CheckIsValid(this.programData.expiry_date),
          error: !this.programData.expiry_date,
          message: "Expired Date harus diisi"
        },
        program_description: {
          isValid: this.CheckIsValid(this.programData.program_description),
          error: this.programData.program_type === "With Content" && !this.programData.program_description,
          message: "Deskripsi harus Diisi"
        },
        program_term_condition: {
          isValid: this.CheckIsValid(this.programData.program_term_condition),
          error: this.programData.program_type === "With Content" && !this.programData.program_term_condition,
          message: "Syarat harus Diisi"
        },
        attachment_program_photo_url: {
          ...this.decideBannerImageError()
        },
        attachment_program_subphoto_url: {
          ...this.decideCardImageError()
        }
      }
    },
    errorForms() {
      return Object.values(this.validate).filter((form) => form.error === true)[0]
    },
    isFormValueEmpty() {
      return Object.values(this.programData).filter((form) => form)
    },
    getImgDimension() {
      return {banner: this.bannerImgDimension, card: this.cardImgDimension}
    }
  },
  methods: {
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "MARKETING" ||
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      if (
          JSON.stringify(this.programData) !==
          JSON.stringify(this.programDataNew)
        ) {
      return Swal.fire({
        icon: "info",
        title: "Are you sure want to leave?",
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
        showCloseButton: true
      }).then((result) => {
        if (result.isConfirmed) {
          this.usersOpened
            ? this.$router.go(-1)
            : this.$router.push({ path: "/management/program" });
        }
      })
      } else {
          this.usersOpened
            ? this.$router.go(-1)
            : this.$router.push({ path: "/management/program" });
      }
    },
    handleProgramType(event) {
      this.programType = event.target.value;
      this.programData.program_type = event.target.value;
    },
    handleProgramName(event) {
      this.isEdited = true
      var slug = event
        .replaceAll(/[^A-Za-z0-9 -]/g, "")
        .replaceAll(" ", "-")
        .replaceAll("--", "-")
        .toLowerCase()
        .trim();
      document.getElementById("program_slug").value = slug;
      this.programData.program_slug = slug;
      this.programData.program_name = event;
    },
    handleProgramSlug(event) {
      var slug = event
        .replaceAll(/[^A-Za-z0-9 -]/g, "")
        .replaceAll(" ", "-")
        .replaceAll("--", "-")
        .toLowerCase()
        .trim();
      document.getElementById("program_slug").value = slug;
      this.programData.program_slug = slug;
    },
    handleActiveDate(event) {
      this.programData.active_date = event;
    },
    handleExpireDate(event) {
      this.programData.expiry_date = event;
    },
    handleProgramDescription(event) {
      this.programData.program_description = event;
    },
    handleProgramTermCondition(event) {
      this.programData.program_term_condition = event;
    },
    handleProgramUrl(event) {
      this.programData.program_url = event;
    },
    handleStatusProgram(event) {
      this.programData.status = event.target.value;
    },
    async readURL(e) {
      if (e.length) {
        const file = e[0];
        this.url = URL.createObjectURL(file);
        this.bannerImgDimension = await this.addImageProcess(this.url)
        this.programData.attachment_program_photo_url = e[0];
      }
    },
    async readSubPhotoURL(e) {
      if (e.length) {
        const file = e[0];
        this.subPhotoUrl = URL.createObjectURL(file);
        this.cardImgDimension = await this.addImageProcess(this.subPhotoUrl)
        this.programData.attachment_program_subphoto_url = e[0];
      }
    },
    updateProgram() {
      this.showErrorField = true
      if (this.errorForms && this.errorForms.error) {
        return 
      }
      var today = new Date();
      var time = ` ${today.getHours()}:${today.getMinutes()}`;
      var activeDate = moment(this.programData.active_date + time).format();
      var expireDate = moment(this.programData.expiry_date + time).format();
      this.programData.active_date = activeDate;
      this.programData.expiry_date = expireDate;
      let ProgramID = this.$route.params.id;
      let formData = new FormData();
      formData.append("meta_info_description", this.programData.meta_info_description);
      formData.append("meta_info_keyword", this.programData.meta_info_keyword);
      formData.append("program_name", this.programData.program_name);
      formData.append("program_slug", this.programData.program_slug);
      formData.append("program_type", this.programData.program_type);
      formData.append("active_date", this.programData.active_date);
      formData.append("expiry_date", this.programData.expiry_date);
      formData.append(
        "program_description",
        this.programData.program_description
      );
      formData.append(
        "program_term_condition",
        this.programData.program_term_condition
      );
      formData.append("program_url", this.programData.program_url);
      formData.append(
        "attachment_program_photo_url",
        this.programData.attachment_program_photo_url
      );
      formData.append("alt_program_photo_url", this.programData.alt_program_photo_url);
      formData.append(
        "attachment_program_subphoto_url",
        this.programData.attachment_program_subphoto_url
      )
      formData.append("alt_program_subphoto_url", this.programData.alt_program_subphoto_url);
      formData.append("status", this.programData.status);
      axios
        .put(`${this.domain}/v1/program/update/${ProgramID}`, formData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Program Data Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/management/program` });
        })
        .catch((err) => {
          this.programData.active_date = moment(
            String(this.programData.active_date)
          ).format("YYYY-MM-DD");
          this.programData.expiry_date = moment(
            String(this.programData.expiry_date)
          ).format("YYYY-MM-DD");
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id,
          });
        });
    },
    CheckIsValid(val) {
      return this.showErrorField && !val ? false : null
    },
    decideBannerImageError() {
      if (!this.programData.attachment_program_photo_url) {
        return {
          error: true,
          isValid: this.CheckIsValid(false),
          message: "Banner Image File harus diisi"
        }
      }
      if (this.programData.attachment_program_photo_url && 
        this.programData.attachment_program_photo_url["size"] > 250000
      ) {
        return {
          error: true,
          isValid: this.CheckIsValid(false),
          message: "File size should be below 250KB"
        }
      }
      if (
        (this.getImgDimension.banner.width !== 720) ||
        (this.getImgDimension.banner.height !== 360)
        ) {
        return {
          error: true,
          isValid: this.CheckIsValid(false),
          message: "Picture must be size is 720px x 360px"
        }
      } 
      return {
        error: false,
        isValid: null,
        message: ""
      }
    },
    decideCardImageError() {
      if (!this.programData.attachment_program_subphoto_url) {
        return {
          error: true,
          isValid: this.CheckIsValid(false),
          message: "Promo Image Card harus diisi"
        }
      }
      if (this.programData.attachment_program_subphoto_url && 
        this.programData.attachment_program_subphoto_url["size"] > 150000
      ) {
        return {
          error: true,
          isValid: this.CheckIsValid(false),
          message: "File size should be below 250KB"
        }
      }
      if (
        (this.getImgDimension.card.width !== 300) ||
        (this.getImgDimension.card.height !== 150)
        ) {
        return {
          error: true,
          isValid: this.CheckIsValid(false),
          message: "Picture must be size is 300px x 150px"
        }
      }
      return {
        error: false,
        isValid: null,
        message: ""
      }
    },
    addImageProcess(src){
      return new Promise((resolve, reject) => {
        let img = new Image()
        img.onload = () => resolve({width: img.width, height: img.height})
        img.onerror = reject
        img.src = src
      })
    },
  },
  validator(val) {
    return val ? val.length >= 4 : false;
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Poppins&display=swap");
@import "./Program.css";
</style>
<style>
.form-group.required .col-form-label::after {
  content: "*";
  color: red;
}
.form-row.required .col-form-label::after {
  content: "*";
  color: red;
}
</style>
